import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { CTAButton } from './CTAButton';
const myths = [{
  lie: "If it's from God, I'll feel perfect peace.",
  truth: "Jesus prayed in agony at Gethsemane. Peace doesn't mean the absence of difficulty."
}, {
  lie: "If I have doubts, it's not right.",
  truth: 'Doubt is not the enemy of discernment. Confusion without a filter is.'
}, {
  lie: 'I just need to pray more and the answer will come.',
  truth: 'Prayer without a framework is just rehearsing the same loop with your eyes closed.'
}, {
  lie: 'Spiritually mature people just know.',
  truth: 'Discernment is a skill, not a spiritual gift reserved for the elite.'
}, {
  lie: "There's one perfect answer — and if I miss it, everything is ruined.",
  truth: 'God works with your decisions, not around them. What you need is clarity for the next step — not the whole map.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function MythsSection() {
  return <section className="py-20 md:py-28 px-4 bg-cream watermark-bg" data-id="element-177">
      <div className="max-w-3xl mx-auto" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-179">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-180">
            The 5 Lies That Are Keeping You Stuck Right Now
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="space-y-4" data-id="element-181">
          {myths.map((myth, index) => <motion.div key={index} variants={itemVariants} className="bg-white p-6 md:p-8 rounded-xl shadow-sm border border-warm-gray flex gap-4 items-start" data-id="element-182">
              <div className="flex-shrink-0 mt-1" data-id="element-183">
                <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center" data-id="element-184">
                  <X className="w-5 h-5 text-red-500" strokeWidth={3} data-id="element-185" />
                </div>
              </div>
              <div data-id="element-186">
                <p className="text-lg font-bold text-charcoal mb-2" data-id="element-187">
                  <span className="text-red-500/80 mr-2 text-sm uppercase tracking-wider" data-id="element-188">
                    Lie #{index + 1}:
                  </span>
                  "{myth.lie}"
                </p>
                <p className="text-charcoal/80 leading-relaxed" data-id="element-189">
                  <span className="font-semibold text-gold mr-2" data-id="element-190">Truth:</span>
                  {myth.truth}
                </p>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="mt-12 text-center" data-id="element-191">
          <p className="text-xl font-serif italic text-charcoal/90 mb-8" data-id="element-192">
            The problem was never your faith. The problem was never your heart.
            <br className="hidden md:block" data-id="element-193" />
            <span className="font-bold not-italic text-gold" data-id="element-194">
              The problem was that nobody gave you a system.
            </span>
          </p>
          <CTAButton mainText="GET THE SYSTEM — $17.95" subText="A 5-minute framework you can use tonight." large data-id="element-195" />
        </motion.div>
      </div>
    </section>;
}